<template>
	<b-modal
		v-model="show"
		:header="false"
		:footer="false"
		class="fade backdrop"
		@hide="close"
	>
		<div slot="default">
			<div class="iadsa-modal-header">
				<b-btn class="close btn btn-head-modal" @click="show=false">
					<i class="material-icons">close</i>
				</b-btn>
			</div>
			<div class="iadsa-modal-body">
				<h5>My profile</h5>
				<h2>Update your name</h2>
				<div class="form-group">
					<div class="row">
						<div class="col-xs-6">
							<label
								v-if="$v.newFirstName.$error && !$v.newFirstName.required"
								class="label error pull-right"
							>Required</label>
							<label>First name</label>
							<input
								v-model="newFirstName"
								type="text"
								:class="{ 'error': $v.newFirstName.$error }"
								class="form-control"
								style="height:40.25px;"
								placeholder="First name"
								@keyup.enter="update(details.id)"
							/>
						</div>
						<div class="col-xs-6">
							<label
								v-if="$v.newLastName.$error && !$v.newLastName.required"
								class="label error pull-right"
							>Required</label>
							<label>Last name</label>
							<input
								v-model="newLastName"
								type="text"
								:class="{ 'error': $v.newLastName.$error }"
								class="form-control"
								style="height:40.25px;"
								placeholder="Last name"
								@keyup.enter="update"
							/>
						</div>
					</div>
					<div style="margin-top:30px">
						<b-btn type="danger" @click="show=false">
							Close
						</b-btn>
						<b-btn type="primary" @click="update">
							<strong>Save</strong>
						</b-btn>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<style lang="less" scoped>
	.btn {
		margin-right: 5px;
	}
	.error {
		border-color: red;
		color: red;
	}
</style>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
	props: {
		showPersonalDetailsModal: {
			type: Boolean,
			required: true
		},
		details: {
			type: Object,
			default: () => ({})
		}
	},
	validations: {
		newFirstName: { required, minLength: minLength(1) },
		newLastName: { required, minLength: minLength(1) }
	},
	data() {
		return {
			show: false,
			newFirstName: null,
			newLastName: null
		};
	},
	watch: {
		showPersonalDetailsModal() {
			this.show = this.showPersonalDetailsModal;
		}
	},
	methods: {
		close() {
			this.$emit('closePersonalDetailsModal');
		},
		update() {
			if (this.$v.$invalid) {
				this.$v.$touch();
			} else {
				this.$emit('updatePersonalDetails', {
					first_name: this.newFirstName,
					last_name: this.newLastName
				});
				this.newFirstName = null;
				this.newLastName = null;
			}
		}
	}
};
</script>
